module.exports = __webpack_public_path__ + "img/arrow-right16_R.04a62f81.svg";